import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/firm/referral-profile")({
  beforeLoad: () => {
    throw redirect({ to: "/referrals/directory-profile" });
  },
});
